import React, { useState } from "react";
import { useExpenses } from "./provider";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import FormExpenses from "./FormExpenses";
import ModalBox from "../../ui/ModalBox";

const UpdateExpenses = () => {
  const [open, setOpen] = useState(false);
  const {state:{selectedExpense}} = useExpenses()
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <div>
    <Typography variant="Poster" component="h4" gutterBottom
   >
     Edit Expense
   </Typography>
   <FormExpenses expense={selectedExpense} handleSuccess={handleSuccess} />
   <ModalBox
     open={open}
     handleClose={handleClose}
     text="The update operation has been completed successfully.. You updated expense"
     name="Expense"
   />
 </div>
  )
};

export default UpdateExpenses;
